<template>
    <v-container fluid grid-list-md>
        <announcements></announcements>
    </v-container>
</template>
<script>
import Announcements from '@/components/Announcements/AdminList.vue';
export default {
    components: {
      Announcements
    }
};
</script>
